import has from 'lodash/has';

import { Education } from '../types/education.enum';

/**
 * Check if the given education is valid
 */
export const isValidEducation = (education?: string | null): boolean => {
  if (!education) {
    return false;
  }
  return !!has(Education, education);
};
